import React from 'react'
import './CustomButton.css'

export const BTN_TYPE_MAP = {
  continue: 'continue',
  back: 'back', 
  refresh: 'refresh'
}

export const CustomButton = (props) => {
  const { type, text, isDisabled=false, onClick } = props;

  return (
    <button 
      disabled={isDisabled} 
      className={'custom-button ' + (type ? 'custom-button__' + type : '')}
      onClick={onClick}
    >
      {
        type === BTN_TYPE_MAP.back 
        && <svg className='custom-button__back-icon' width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.20975 11.3574L0.433882 6.52459C0.300291 6.36561 0.200098 6.17485 0.200098 6.01587C0.200098 5.8251 0.300291 5.63434 0.433882 5.47536L5.20975 0.642567C5.51033 0.324619 6.0113 0.324619 6.34528 0.610772C6.67925 0.896924 6.67925 1.37385 6.37867 1.69179L2.10377 6.01587L6.37867 10.3082C6.67925 10.6261 6.67925 11.103 6.34528 11.3892C6.0113 11.6753 5.51033 11.6753 5.20975 11.3574Z" fill="#181871"/>
          </svg>
      }
      
      { text }

      {
        type === BTN_TYPE_MAP.continue 
        && <svg className='custom-button__continue-icon' width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5903 0.642616L6.36617 5.47541C6.49976 5.63439 6.59995 5.82515 6.59995 5.98413C6.59995 6.1749 6.49976 6.36566 6.36617 6.52464L1.5903 11.3574C1.28972 11.6754 0.788751 11.6754 0.454774 11.3892C0.120796 11.1031 0.120796 10.6262 0.421376 10.3082L4.69628 5.98413L0.421376 1.69184C0.120796 1.37389 0.120796 0.896974 0.454774 0.610821C0.788751 0.324669 1.28972 0.324669 1.5903 0.642616Z" fill="#181871"/>
          </svg>
      }

      

      {
        type === BTN_TYPE_MAP.refresh 
        && <svg className='custom-button__refresh-icon ' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.985816 1.11426C1.23409 1.02855 1.53754 1.08569 1.70306 1.28569L2.86168 2.45712C3.99271 1.28569 5.53754 0.599976 7.19271 0.599976C10.6134 0.628547 13.3996 3.48569 13.3996 6.99998C13.3996 10.5428 10.6134 13.4 7.2203 13.4C5.75823 13.4 4.35133 12.8857 3.24789 11.9428C2.97202 11.6857 2.94444 11.2571 3.16513 10.9714C3.4134 10.6857 3.8272 10.6285 4.10306 10.8857C4.95823 11.6285 6.06168 12.0285 7.2203 12.0285C9.89616 12.0285 12.0755 9.79998 12.0755 6.99998C12.0755 4.22855 9.89616 1.9714 7.2203 1.9714C5.89616 1.9714 4.70995 2.54283 3.79961 3.42855L5.23409 4.94283C5.4272 5.11426 5.48237 5.42855 5.39961 5.68569C5.28926 5.94283 5.04099 6.08569 4.79271 6.08569H1.26168C0.875471 6.08569 0.599609 5.79998 0.599609 5.39998V1.74283C0.599609 1.48569 0.73754 1.22855 0.985816 1.11426Z" fill="#181871"/>
          </svg>
      }

      
    </button>
  )
}
